import React, { FC } from 'react'
import s from './CardService.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'

interface Props {
  title: string
  subtitle: string
  description: string
  img: string
  maxLineDescription?: number
  className?: string
  handleClick?: () => void
}

const CardService: FC<Props> = ({
  title,
  subtitle,
  description,
  img,
  maxLineDescription,
  className = '',
  handleClick,
}) => {
  const handleClickInner = () => {
    handleClick && handleClick()
  }

  return (
    <ErrorBoundary>
      <div className={`${s.card} ${className}`} onClick={handleClickInner}>
        <div className={s.img}>
          {/* @ts-ignore */}
          <img
            src={img || ''}
            alt={title}
            style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute' }}
          />
        </div>

        <div className={s.content}>
          <Text sizes={'L ML ML ML'} className={s.title}>
            {title}
          </Text>

          {subtitle && (
            <Text sizes={'M S S S'} className={s.subtitle}>
              {subtitle}
            </Text>
          )}

          <div
            className={s['description-wrapper']}
            style={{ WebkitLineClamp: maxLineDescription ? maxLineDescription : 'initial' }}>
            <Text sizes={'M S S S'} className={s.description}>
              {description}
            </Text>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default CardService
